<div class="toaster">
  <div class="list">
    <div class="toast" [ngClass]="t.expired ? 'fading' : ''" *ngFor="let t of messages" 
    [ngStyle]="{ background: t.color }">
      {{t.text}}
    </div>
  </div>
</div>